import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TopnavComponent } from './topnav.component';
import { TopnavitemComponent } from './topnavitem/topnavitem.component';
import { WmInputModule } from '../input/index';
import { WmIconModule } from '../icon/index';
import { WmMenuModule } from '../menu/index';
import { RouterModule } from '@angular/router';

@NgModule({
	declarations: [TopnavComponent, TopnavitemComponent],
	imports: [CommonModule, WmInputModule, WmIconModule, WmMenuModule, RouterModule],
	exports: [TopnavComponent, TopnavitemComponent]
})
export class WmTopnavModule {}
